import { Grid, makeStyles, Paper, Typography } from '@material-ui/core';
import useReportQueryParams from 'components/ReportsModule/hooks/use-report-query-params';
import React from 'react';
import {
  PrmStudentCurriculumLessonReportResult,
  StudentLicenseUsage
} from 'types/schema-generated-types';
import formatDateString from 'utilities/format-date-string';
type Props = {
  studentLessonReport: PrmStudentCurriculumLessonReportResult;
};

const StudentDetailsCard: React.FC<Props> = ({ studentLessonReport }) => {
  const [{ productFamilyCode }] = useReportQueryParams();

  const filterActive = (licenseUsage: StudentLicenseUsage[]) => {
    const result = licenseUsage?.find(
      x => x?.product?.family?.code === productFamilyCode && x.active === true
    );

    return result;
  };
  const classes = useStyles();

  return (
    <Paper className={classes.card}>
      <Grid container xs={12} direction="column" style={{ padding: 50 }}>
        <Grid xs={6} item>
          <Typography className={classes.title}>Grade</Typography>
          <Typography className={classes.valueText}>
            {studentLessonReport?.student?.gradeLevel}
          </Typography>
        </Grid>
        <Grid xs={6} item>
          <Typography className={classes.title}>License</Typography>
          {studentLessonReport?.student?.licenseUsage ? (
            <Typography className={classes.valueText}>
              {filterActive(studentLessonReport?.student?.licenseUsage!)?.productCurriculum?.code}
            </Typography>
          ) : (
            <Typography className={classes.valueText}>--</Typography>
          )}
        </Grid>
        <Grid xs={6} item>
          <Typography className={classes.title}>Last login</Typography>
          {studentLessonReport?.curriculumDetail?.lastLoginDate ? (
            <Typography className={classes.valueText}>
              {formatDateString(new Date(studentLessonReport?.curriculumDetail?.lastLoginDate))}
            </Typography>
          ) : (
            <Typography className={classes.valueText}>--</Typography>
          )}
        </Grid>
        <Grid xs={6} item>
          <Typography className={classes.title}>Current Lesson</Typography>
          {studentLessonReport?.curriculumDetail?.currentLesson?.lessonNumber ? (
            <Typography className={classes.valueText}>
              Lesson {studentLessonReport?.curriculumDetail?.currentLesson?.lessonNumber} of{' '}
              {studentLessonReport?.curriculumDetail?.totalLessonCount}
            </Typography>
          ) : (
            <Typography className={classes.valueText}>--</Typography>
          )}
        </Grid>
      </Grid>
    </Paper>
  );
};

const useStyles = makeStyles(() => ({
  card: {
    display: 'flex',
    flex: 1,
    height: 317
  },
  title: {
    color: '#A9A9A9'
  },
  valueText: {
    fontWeight: 500
  }
}));

export default StudentDetailsCard;
